import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { clearForcedFlags, useForcedFlags } from './useFeatureFlag';

/**
 * Local builds only: says which features are forced on in this browser, so a
 * remembered `?flags=` is never mistaken for the real state (2026-10-16 — the
 * Settings tab "showing without the flag" was exactly that). Renders nothing
 * when no flag is forced, and always nothing in a deployed build, where
 * `?flags=` is ignored. A click forgets the forced flags and reloads.
 */
export const ForcedFlagsChip = () => {
  const { t } = useTranslation('pmShell');
  const forced = useForcedFlags();
  if (forced.length === 0) return null;

  const features = forced.map((flag) => t(`flagPreview.feature.${flag}`)).join(', ');
  return (
    <Tooltip title={t('flagPreview.Tooltip')}>
      <Chip
        label={t('flagPreview.Label', { features })}
        color="purple"
        size="small"
        onClick={clearForcedFlags}
        data-automation-id="forced-flags-chip"
      />
    </Tooltip>
  );
};
